import React from 'react';
import PropTypes from 'prop-types';

import Question from './Question';
import '../style/questions.css';

const DisplayStatesOrCaps = q => (
  q === 'Capitals' ? 'Click the State That Matches the Capital on the Map' : 'Click the Matching State on the Map'
);

const DisplayMsg = q => (
  ` | ${DisplayStatesOrCaps(q)} | `
);

const QuestionContainer = ({ current, qtype, refresh }) => (
  <div className="question__container">
    <div className="intro">
      <a href="/">Home</a>
      {DisplayMsg(qtype)}
      <button className="refresh" id={qtype} onClick={refresh}>&#8635;</button>
    </div>
    <Question current={current} qtype={qtype} />
  </div>
);

QuestionContainer.propTypes = {
  current: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    capital: PropTypes.string.isRequired,
    misses: PropTypes.number,
  }).isRequired,
  qtype: PropTypes.string.isRequired,
  refresh: PropTypes.func.isRequired,
};

export default QuestionContainer;



// WEBPACK FOOTER //
// ./src/components/QuestionContainer.js